import intersection from 'lodash/intersection'
import { Role } from '../enums'

export const userIsPermitted = (permittedRoles = [], { roles: userRoles }) => {
  // Granted if any of users' roles are permitted
  // If no permitted roles were specified, grant only admins
  const permissionGranted = !!intersection([...permittedRoles, Role.ADMIN], userRoles).length
  return permissionGranted
}
